import { DefaultAttributeValue } from '@source-components-react/types';

/**
 * Nothing is seeded, including the URL.
 *
 * A freshly dropped embed renders nothing until an author pastes something,
 * which is the honest result: the alternative is shipping a placeholder video
 * that a customer's page would publish if anyone forgot to replace it. The
 * palette card and the empty drawer say what to do instead.
 *
 * Aspect ratio is left unset on purpose too, so it resolves from the provider
 * — a map is 4:3 and a video is 16:9 without either being written down here.
 */
export const defaultAttributeValues: DefaultAttributeValue[] = [
  {
    name: 'embed-url-3-resolutions',
    defaultValues: {},
  },
  {
    name: 'embed-title-3-resolutions',
    defaultValues: {},
  },
  {
    name: 'embed-aspect-ratio-3-resolutions',
    defaultValues: {},
  },
  {
    name: 'embed-loading-3-resolutions',
    defaultValues: {},
  },
];
